// Step01_Company.js
import React, { useState } from 'react';
import { useForm } from '../context/FormContext';

export default function Step01_Company({ onNext }) {
  const { state, dispatch } = useForm();
  const [err, setErr] = useState('');

  const val = state.companyOfApplication;

  const next = () => {
    if (!val.trim()) { setErr('Company name is required'); return; }
    setErr('');
    onNext();
  };

  return (
    <div className="step-card">
      <h2 className="step-title">Company of Application</h2>
      <p className="step-subtitle">What company are you applying to work for?</p>
      <div className="field-group">
        <label className="field-label">Company Name <span className="required">*</span></label>
        <input
          className={`field-input ${err ? 'error' : ''}`}
          value={val}
          onChange={e => { dispatch({ type: 'SET_FIELD', key: 'companyOfApplication', value: e.target.value }); setErr(''); }}
          placeholder="Enter company name"
          autoFocus
        />
        {err && <div className="field-error">{err}</div>}
      </div>
      <div className="wizard-nav" style={{ position: 'static', borderTop: 'none', padding: 0, marginTop: 24 }}>
        <button className="btn-next" onClick={next}>Next →</button>
      </div>
    </div>
  );
}
